import React from 'react';
import './hero.scss';

export default class Hero extends React.Component {
  constructor(props) {
    super(props);
    this.state = { locked: '' };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll.bind(this));
  }

  handleScroll(event) {
    // if (event.srcElement.body.scrollTop > window.innerHeight + 100) {
    //   this.setState({ locked: 'hero--scrolled' });
    // } else {
    //   this.setState({ locked: '' });
    // }
  }

  render() {
    return (
      <div className="hero">
        <div className={this.state.locked}>
          <div className="hero__background" />
          <div className="hero__slogan" />
          <div
            alt={this.props.title}
            title={this.props.title}
            className="hero__overlay"
          />
          <div className="hero__title">
            {this.props.title}
          </div>
          <div className="hero__copy">
            Founded by Zooey Deschanel and Jacob Pechenik,<br />The Farm Project
            empowers initiatives that reconnect people with food.
          </div>
        </div>
      </div>
    );
  };
};



// WEBPACK FOOTER //
// ./src/components/hero.js